<!-- App.vue -->
<template>
    <first-component :culture="culture"></first-component>
</template>

<script>
import FirstComponent from './FirstComponent.vue';

export default {
    components: {
        FirstComponent,
    },
    props: {
        culture: {
            type: String,
            required: true,
        },
    },
};
</script>

<style scoped>
/* Add component-specific styles here */
</style>